import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import { useApi } from '@/lib/api-context';

import { verifyResponseSchema, type VerifyResult } from './signature-verify';

export interface Verification {
  result: VerifyResult;
  /** Momento en que se verificó, para mostrarlo junto al resultado. */
  at: Date;
}

/** Verificación a demanda de una firma (spec 2026-10-14 §6 D3): la cadena puede ser
 *  larga, por eso no se consulta al abrir la ficha. Una respuesta con otra forma cae al
 *  error, nunca a "íntegra". */
export function useVerifySignature(
  signatureId: string,
): UseMutationResult<Verification, Error, void> {
  const api = useApi();
  return useMutation({
    // Una firma por clave: el resultado de otra (otra ficha, otra versión) no se arrastra.
    mutationKey: ['verify-signature', signatureId],
    mutationFn: async () => {
      const raw = await api.get<unknown>(`/api/v1/signatures/${signatureId}/verify`);
      return { result: verifyResponseSchema.parse(raw).data, at: new Date() };
    },
  });
}
